import { ICommonResponse } from 'api/types';
import { AcademicYearTitle } from 'components/pdfStudent';
import { splittedDataToSortedArray } from 'containers/pdfStudent/utils/splittedDataToSortedArray';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetStudyEducation } from 'icons/widgets';
import FormatGrid from 'portfolio3/features/pdf/components/FormatGrid';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { IEntity } from 'types';
import { getDataLoadRequests } from 'utils';

import { PdfCommonDataEntity } from '../../../../components/pdfStudent/DataEntity';
import { studySpoTrainingSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const getTrainingByAcademicYear = (data: ICommonResponse<IEntity>, academicYears: string[]) => {
  const learningYearData: Record<string, IEntity[]> = {};

  data.content.forEach((item) => {
    const period = item.formData.learningYear.split('/').join('-');
    if (academicYears.includes(period)) {
      if (learningYearData[period]) {
        learningYearData[period].push(item);
      } else {
        learningYearData[period] = [item];
      }
    }
  });

  return splittedDataToSortedArray(learningYearData);
};
const PdfTrainingContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const training = useAppSelector(studySpoTrainingSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().studySpoEducation });

  const hasData = training.content.length > 0;

  const academicYearData = getTrainingByAcademicYear(training, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Сведения об обучении" Icon={IconWidgetStudyEducation}>
      {hasData &&
        academicYearData.map(([academicYear, data]) => (
          <div key={academicYear}>
            <AcademicYearTitle academicYear={academicYear} />
            <FormatGrid>
              {data.map((entity) => (
                <PdfCommonDataEntity key={entity.id || entity.recordId} entity={entity} />
              ))}
            </FormatGrid>
          </div>
        ))}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfTrainingContainer;
